import { useEffect, useState } from "react";
import styles from "./Planos.module.css";
import { Link } from "react-router-dom";
import load from "../../Images/loading.gif";

function Planos() {
    const [planos, setPlanos] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPlanos = async () => {
        try {
            const response = await fetch("https://eclipsebots.com/api/planos/get", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch planos");
            }

            const data = await response.json();

            setPlanos(data);
        } catch (error) {
            console.error("Erro ao buscar planos:", error);
            setPlanos([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlanos();
    }, []);


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    return (
        <div className={styles.content}>
            <div className={`${styles.size} ${styles.planos}`}>
                <div className={styles.presentation}>
                    <div className={styles.title}>Encontre seu plano ideal, sem complicação!</div>
                    <div className={styles.description}>
                        Selecione a opção que encaixa perfeitamente no seu dia a dia e desfrute dos nossos serviços sem entraves.
                    </div>
                </div>
                <div className={styles.center}>
                    {planos.length === 0 && (
                        <div>Não há nenhum plano de momento</div>
                    )}
                    {planos.map((plano, index) => {
                        const pontos = plano.points.replace(/\\n/g, "\n").split("\n");

                        return (
                            <div className={styles.plano}>
                                <div className={styles.header}>
                                    <div className={styles.image}>
                                        <img src={plano.image} alt="Imagem do Plano" />
                                    </div>
                                    <div className={styles.details}>
                                        <div className={styles.title}>{plano.name}</div>
                                        <div className={styles.description}>{plano.description}</div>
                                    </div>
                                </div>
                                <div className={styles.content}>
                                    <div className={styles.price}>R$ {plano.price} <span>/{plano.cycle === "mensal" ? "mês" : "semana"}</span></div>
                                    <div className={styles.adquirir}>
                                        <Link style={{ textDecoration: "none", color: "white" }} to={`checkout/${plano.planId}`}>
                                            <button>Adquirir</button>
                                        </Link>
                                    </div>
                                </div>
                                <div className={styles.topics}>
                                    {pontos.map((ponto, i) => (
                                        <div key={i} className={styles.topic}>
                                            <span className={styles.icon}>✓</span> {ponto}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Planos;